// Vue
import { PropType } from "vue";

// Types
import { ThemeConfigType } from "../types/ThemeConfigType";

const themeProp = {
  theme: {
    type: String as PropType<keyof ThemeConfigType>,
    default: "appBlue",
    validator(value: string) {
      return ["appBlue", "appGreen", "appYellow", "appRed", "appPurple", "slate", "switch"].includes(value);
    },
  },
};

export { themeProp };
